import { WithDefaultLayout } from '../../../components/DefautLayout';
import { Title } from '../../../components/Title';
import { Page } from '../../../types/Page';
import { SectionFreeCourseProcedure } from '@/components/home/SectionFreeCourseProcedure';
import { BenefitPoint } from '@/components/program/BenefitPoint';
import { ChecklistProgram } from '@/components/program/ChecklistProgram'
import { NewSkillBox } from '@/components/program/NewSkillBox';
import Link from 'next/link';
import MobileAppFreeCourseSchedule from '@/components/course/schedule/MobileAppFreeCourseSchedule';
import { MobileAppCourseReason } from '@/components/course/section/MobileAppCourseReason';
import { HeaderSection } from '@/components/common/headers/HeaderSection';
const FreeCourseMobileApp: Page = () => {

    return (
        <div>
            <Title title={'Free Course - Mobile Application'} description='' />
            <section id='landing-page-mobile-application' className='flex flex-wrap justify-between items-center'>
                <div className='text-2xl mx-5 mb-4'>
                    <div className='m-5 p-5'>
                        <img src='/img/layouting/logo-accelist.png' style={{ width: 74 }} alt='img' />
                        <p className='text-3xl font-bold text-accelist-green mb-3 md:mb-5 mt-4'>Free Course</p>
                        <p className='text-3xl md:text-3xl text-slate-900 font-bold'>Introduction to</p>
                        <p className='text-3xl md:text-3xl text-slate-900 font-bold mb-2'>IT Programming</p>
                        <div className='w-fit bg-slate-900 rounded-lg px-2 py-2 mt-3 md:mt-5 text-center' style={{ width: 250 }}>
                            <p className='text-white text-base md:text-lg text-center px-2'>Kelas Mulai : Desember 2023</p>
                        </div>
                        <p className='text-xl md:text-2xl text-slate-900 font-bold mt-4 md:mt-3'>Mobile Application</p>
                        <p className='text-base md:text-lg text-slate-900 font-bold mt-2 md:mt-3'>1 Jam Belajar + Demonstrasi Project</p>
                        <p className='text-sm md:text-base text-gray-400 mt-2 '>Pengajaran untuk memahami front-end Mobile</p>
                        <p className='text-sm md:text-base text-gray-400 mb-2'>Application (Android dan iOS) dengan coding</p>
                        <div className="bg-accent-100 rounded-md hover:bg-black duration-300 flex justify-center items-center mt-6 mb-2" style={{ width: 200, height: 50 }}>
                            <Link href="/courses/register" className="block duration-300 text-white hover:text-white text-lg md:text-xl text-accelist-font">
                                Daftar Gratis
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='relative m-0 flex justify-end'>
                    <img src='/img/course/free-course-mobile-application.png' alt='Free Course - Mobile Application.png' style={{ height: '700px' }} />
                    <div className='absolute inset-0 bg-[#3B4687CC] opacity-80'></div>
                    <div className='absolute inset-0 flex flex-col items-center justify-center'>
                        <p className='text-2xl md:text-2xl font-bold text-white'>Paham Buat Aplikasi Android dan iOS</p>
                        <p className='text-2xl md:text-2xl mb-1 font-bold text-white'>via Coding Dalam 1 Jam!</p>
                        <div className='border-2 md:border-2 border-white rounded-full mb-6' style={{ width: '28rem' }} />
                        <div className="bg-slate-800 rounded-xl py-2" style={{ width: '400px' }}>
                            <p className='text-lg md:text-lg font-bold ml-6 mt-4 mb-4 text-white'>Benefit yang didapatkan</p>
                            <div className='text-md flex flex-col flex-wrap text-white pb-2'>
                                <ChecklistProgram name='Cocok bagi pemula' />
                                <ChecklistProgram name='Sesi Interaktif via Live Zoom' />
                                <ChecklistProgram name='Diajar oleh expert di Perusahaan IT' />
                                <ChecklistProgram name='Software Skill; JavaScript, TypeScript, React Native, Expo' />
                                <ChecklistProgram name='Sertifikat digital terverifikasi Disnaker' />
                                <ChecklistProgram name='Pemahaman pembuatan mobile application untuk platform Android dan IOS menyeluruh' />
                            </div>
                            <div className="flex justify-center items-center mt-5 mb-3">
                                <div className="bg-[#F8FAFC] rounded-md" style={{ width: '25rem', height: '2.5rem' }}>
                                    <div className="flex justify-center items-center text-black font-bold text-md mt-2">
                                        <p className="pl-2 mr-4 pr-4 mb-8 border-r border-gray-400 ">Konten Live Session</p>
                                        <p className="mb-8 mx-1">Sesi Sharing</p>
                                        <p className="ml-4 pl-4 mb-8 border-l border-gray-400">Sertifikasi</p>
                                    </div>
                                </div>
                            </div>
                            <p>
                                <span className="currency">Rp</span>
                                <span className="price">1.000.000</span>
                                <span className="free">GRATIS!</span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section id='program-description' className='bg-program-atas'>
                <div className='mx-24'>
                    <div>
                        <div className='flex flex-wrap items-center justify-center'>
                            <p className='text-4xl font-bold text-white mt-16 mb-5'>Mobile Application</p>
                        </div>
                        <div className='text-2xl text-gray-400 flex items-center justify-center'>

                        </div>
                        <div className='flex items-center justify-center'>
                            <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mb-5' />
                        </div>
                    </div>
                    <div>
                        <div className='text-xl text-white'>
                            <p className='text-3xl font-bold text-white my-10'>Deskripsi</p>
                            <p>Introduction to IT Programming: Mobile Application merupakan salah satu kursus gratis bagi para calon front-end mobile application developer (Android dan iOS). Melalui kursus ini, para peserta akan memulai pembelajaran karir sebagai front-end mobile application developer. Karir ini bertugas untuk membuat dan mengembangkan mobile application yang menarik dan interaktif.</p>
                        </div>
                    </div>
                    <p className='text-3xl font-bold text-white my-10'>Agenda dan Materi</p>
                    <div className='text-xl text-accelist-font flex flex-col flex-wrap text-white pb-10'>
                        <BenefitPoint name='Pemahaman framework React Native + Expo' />
                        <BenefitPoint name='Pemahaman struktur React Native + Expo' />
                        <BenefitPoint name='Pengembangan aplikasi mobile dengan React Native + Expo' />
                        <BenefitPoint name='Karir sebagai front-end mobile application developer' />
                    </div>
                </div>
            </section>
            <section id='program-price' className='py-12'>
                <div className="flex flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-4 md:mb-8 items-center">
                        <HeaderSection
                            title="Biaya Program"
                            subtitle="Biaya dan Durasi Program"
                        />
                    </div>
                    <div className="w-full relative p-5 rounded-xl bg-gradient-to-r from-yellow-900 via-orange-300 to-yellow-900">
                        <div className="flex flex-wrap justify-between w-full pt-12  pl-5 pr-2 md:px-14 h-full bg-secondary-100 rounded-xl">
                            <div className='flex flex-col'>
                                <p className='text-2xl sm:text-4xl font-bold text-[#E2AA71] mb-6'>Mobile Application</p>
                                <p className='text-2xl sm:text-6xl font-bold text-[#E2AA71] mb-16'>FREE!</p>
                                <p className='text-md sm:text-xl font-bold text-[#B3B3B3] mb-3'>Durasi 1 Jam</p>
                                <p className='text-sm  text-[#B3B3B3] mb-16'>Paham Buat Mobile Application (Android & iOS) via coding!</p>
                                <div className='w-fit bg-gradient-to-r from-yellow-900 via-orange-300 to-yellow-900 p-3'>
                                    <Link href="/courses/register" className='hover:bg-orange-300 duration-300 transition ease-in-out bg-gradient-to-r from-orange-900 via-orange-300 to-yellow-800 rounded-md'>
                                        <p className='text-md sm:text-xl text-secondary-100 font-body font-bold'>Daftar Sekarang</p>
                                    </Link>
                                </div>
                            </div>
                            <img src='/img/program/detail-paket-bronze.png' alt='' className='w-fit'></img>
                        </div>
                    </div>
                </div>
            </section>
            <section id='program-schedule' className='py-16'>
                <div className="flex-wrap px-5 md:px-16">
                    <MobileAppFreeCourseSchedule />
                </div>
            </section>
            <section id='acquired-skills' className='pb-10'>
                <div className="px-5 md:px-16 bg-[#f5f5f5]">
                    <div className="flex flex-col mx-auto text-center md:mb-16 items-center gap-6">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed mt-16'>Skill yang Bisa Kamu Tambah di CV!</h2>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mb-5' />
                    </div>
                    <div className='align-middle flex flex-wrap font-semibold justify-center text-md text-black'>
                        <NewSkillBox name='Introduction to Front-End Mobile Development' />
                        <NewSkillBox name='Introduction to React Native' />
                    </div>
                    <div className='align-middle flex flex-wrap font-semibold justify-evenly text-md text-black pb-16'>
                        <NewSkillBox name='Introduction to Expo' />
                        <NewSkillBox name='Introduction to JavaScript' />
                        <NewSkillBox name='Introduction to TypeScript' />
                    </div>
                </div>
            </section>
            <section id='acquired-skills' className='pb-10'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Kenapa Harus Ikut Introduction to IT Programming: Mobile Application?</h2>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5' />
                    </div>
                    <div className='flex flex-wrap justify-evenly'>
                        <MobileAppCourseReason />
                    </div>
                </div>
            </section>
            <section id='achieve-your-dream-with-us' className='bg-program-bawah'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center mt-16">
                        <h2 className='text-white text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Wujudkan Mimpimu Bersama Kami</h2>
                        <p className="text-white text-base font-body font-light align-center mt-1 md:mt-3 sm:text-lg mb-16">Satu langkah untuk mewujudkan mimpi mu</p>
                        <Link href="/courses/register" className="text-sm sm:text-base font-medium font-body bg-accent-100  text-white py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-white hover:text-accent-100 shrink">
                            <p className='text-md sm:text-xl font-body font-bold'>Daftar Gratis</p>
                        </Link>
                    </div>
                </div>
            </section>
            <SectionFreeCourseProcedure />
            <div className="flex flex-col flex-wrap px-5 md:px-16">
                <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                    <Link href="/courses/register" className="text-sm sm:text-base font-medium font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-black hover:text-white shrink">
                        <p className='text-md sm:text-xl text-white font-body font-bold'>Daftar Sekarang</p>
                    </Link>
                </div>
            </div>
        </div>
    )
}

FreeCourseMobileApp.layout = WithDefaultLayout;
export default FreeCourseMobileApp;